import React, { FC } from 'react';

import { Navigate } from 'react-router-dom';

import { useOTPIPCheck } from '@/components/hooks';
import { Loading } from '../../Common/Loading';
import OTPSignIn from './index';

const OTPSignInGuard: FC = () => {
    const ipCheckState = useOTPIPCheck();

    if (ipCheckState === 'loading') {
        return <Loading fullScreen loadingText="Verifying access..." />;
    }

    if (ipCheckState === 'denied') {
        return <Navigate to="/signIn" replace />;
    }

    return <OTPSignIn />;
};

export default OTPSignInGuard;

